import {PaginatedBackendResponse} from '@common/http/backend-response/pagination-response';
import {queryFactoryHelpers} from '@common/http/queries-file-helpers';
import {queryOptions} from '@tanstack/react-query';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {PremiumPlan} from '@app/web-player/premium-plans/premium-plan';

export const premiumQueries = {
  plans: {
    invalidateKey: ['premium-plans'],
    index: (loader?: 'premiumPage') => {
      const key = ['plans', 'index'];
      if (loader) {
        key.push(loader);
      }

      return queryOptions<{plans: PremiumPlan[]}>({
        queryKey: key,
        queryFn: () =>
          queryFactoryHelpers
            .get<PaginatedBackendResponse<PremiumPlan>>('premium-plans')
            .then(r => ({
              plans: r.pagination.data,
            })),
        initialData: () => {
          if (loader) {
            // @ts-ignore
            return getBootstrapData().loaders?.[loader];
          }
        },
      });
    },
  },

  buy: {
    invalidateKey: ['buy'],
    index: (planId: number | string, planName: string) =>
      queryOptions({
        queryKey: [planId, planName],
        queryFn: () => queryFactoryHelpers.get(`buy/${planId}/${planName}`),
      }),
  },
};
